// services/InvitationService.js
import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

export const sendInvitationEmail = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/user/invite`, data);
  console.log("Respuesta invitación:", response);
  return response;
};